import { ContextOption } from './Context';
import { QuestionType } from './QuestionType';

export class SurveyListSurvey {
    instrumentName: string;
    instrumentAlias: string;
    surveyCompleted: boolean;
    surveyId: number;
    surveyDuration: number;
    surveyPriority: number;
    contextOption: ContextOption;
    context?: string;
    firstOpenDate?: string;
}

export interface DemoGraphicSurveyQuestion {
    answerOptions: Array<{ label: string; answer: { languageCode: string; answer: string }[] }>;
    id: number;
    question: Array<{ languageCode: string; question: string }>;
    section: number;
    label: string;
    value?: string;
    order: number;
    questionType: QuestionType;
    view?: string;
}

export interface DemoGraphicSurvey {
    surveyCompleted: boolean;
    questions: DemoGraphicSurveyQuestion[];
    surveyPriority: number;
    surveyDuration: number;
}

export default class SurveyListResponse {
    public name: string = '';
    public projectId: number = 0;
    public customPrivacyLink?: string;
    public surveys: SurveyListSurvey[] = [];
    public demographicSurvey: DemoGraphicSurvey;
    public languages: SurveyListLanguage[];
    public knowledgeModelAlias: string;
    public languageCode: string;
    public knowledgeModelName: string;
    public surveyConfiguration?: SurveyConfiguration;
    public welcomeTexts?: SurveyText[];
    public thankYouTexts?: SurveyText[];
    public closed: boolean;

    constructor(obj?: Partial<SurveyListResponse>) {
        if (obj) {
            Object.assign(this, obj);
        }
    }
}

export class SurveyText {
    public text: string;
    public languageCode: string;
}

export class SurveyConfiguration {
    public disableBackNavigation: boolean;
    public isCombinedSurvey: boolean;
}

export class SurveyListLanguage {
    public name: string;
    public languageCode: string;

    constructor(object?: Partial<SurveyListLanguage>) {
        if (object) {
            Object.assign(this, object);
        }
    }
}
